<app-cookie-consent></app-cookie-consent>

<app-header [account]="account"></app-header>

<app-side-menu
  *ngIf="account && !layout?.sideMenu?.hide && !isCheckout"
></app-side-menu>

<main
  id="content"
  role="main"
  class="flex-grow-1"
  [style.margin-top.px]="mainMarginTop"
  [style.padding-left.px]="
    isXlUp && layout?.sideMenu?.relative ? sideMenuWidth : 0
  "
  [class.has-footer-menu]="hasFooterMenu"
  [class.has-side-menu]="hasSideMenu"
  [class.is-products-page]="isProductsPage()"
  [class.is-cart-checkout-page]="isCartOrCheckoutPage()"
  [class.gpb-16]="
    !layout?.main?.noPaddingBottom &&
    hasSideMenu &&
    !(isProductsPage() || isCartOrCheckoutPage())
  "
  [class.bg-color]="layout?.main?.hasBgColor"
>
  <router-outlet></router-outlet>
</main>

<div
  [class.bg-lightblue-2]="account && !layout?.sideMenu?.hide"
  *ngIf="hasFooterMenu"
>
  <app-bottom-offset
    *ngIf="showBottomOffset()"
    [type]="layout?.footer?.bottomOffset"
  ></app-bottom-offset>
  <div class="gpy-24 gpy-md-0"></div>
  <app-mobile-footer [account]="account"></app-mobile-footer>
</div>
